// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__3s1V7","iconWrapper":"styles_iconWrapper__XIGZP"};